import SerializableObject from '@/utils/models/serializableobject.model';
import Product from '../menu/product.model';

export default class ProductSingleResponse extends SerializableObject {
  MenuProduct?: Product;
}
